import FolderPage from "../pages/FolderPage";

const routes = [
  {
    path: "/folders/:folderId",
    exact: true,
    element: FolderPage,
  },
];

export default routes;
